export default "__VITE_ASSET__CwObZY5U__"